import { compose, withHandlers, withPropsOnChange, withState, lifecycle } from 'recompose';

const defaultActiveSelector = props => props.active;

export default (activeSelector = defaultActiveSelector) => compose(
  withState('ticker', 'setTicker', null),
  withState('clockedMinutes', 'setClockedMinutes', 0),
  withHandlers({
    incrementClockedMinutes: props => () => props.setClockedMinutes(props.clockedMinutes + 1),
  }),
  withPropsOnChange(
    (prevProps, nextProps) => activeSelector(prevProps) !== activeSelector(nextProps),
    (props) => {
      window.clearInterval(props.ticker);
      if (activeSelector(props)) {
        const ticker = window.setInterval(() => {
          props.incrementClockedMinutes();
        }, 60 * 1000);
        props.setTicker(ticker);
        return;
      }

      props.setTicker(null);
      props.setClockedMinutes(0);
    }
  ),
  lifecycle({
    componentWillUnmount() {
      this.props.setTicker(null);
    },
  }),
);
